"use strict";

/**
* @ngdoc service
* @name nms.components.autoUpdater:DevicePollingRESTService
* @description
* # DevicePollingRESTService - Serviço REST para serviços de polling.
* Factory in the nms.
*/
var app = angular.module("nms");

app.factory("DevicePollingRESTService", ["Restangular",
    function(Restangular) {
        const basePath = "/device-management-web";

        return {
            verifyPollingIsRunning(resourceId: number) {
                return Restangular.one(`${basePath}/pollingUnderway/${resourceId}`).customGET();
            },
            requestPolling(resourceId: number) {
                return Restangular.one(`${basePath}/requestPolling?resourceId=${resourceId}`).customPOST();
            },
            requestPollings(pollingRequests: number[]) {
                return Restangular.one(`${basePath}/requestPollings`).customPOST(pollingRequests);
            },
            getFirstPollingStatus(resourceId: number) {
                return Restangular.one(`${basePath}/firstPollingStatus/${resourceId}`).customGET();
            },
            getDevicesPollingUnderway() {
                return Restangular.one(`${basePath}/devicesPollingUnderway`).customGET();
            },
            getPollingTimeoutInMinutes() {
                return Restangular.one(`${basePath}/pollingResponseTimeout`).customGET();
            }
        };
    }
]);
